import { genericRequest } from "./genericRequest";

export const getReports = async (perPage, offset) => {

  return await genericRequest(
    `https://users.ponzilover.com/api/scam_reports/?perPage=${perPage}&offset=${offset}`
  );
};

export const getTotalReports = async () => {

  const totalRows = await genericRequest(
    `https://users.ponzilover.com/api/scam_reports/?getTotal=true`
  );

  return totalRows[0].total || 0;
}

export const hasReportedAlready = async () => {

  const isHavingReports = await genericRequest(
    `https://users.ponzilover.com/api/scam_reports/?hasRecords=true`
  );

  return isHavingReports[0].exists_flag || false;
}